import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WebmasterSidebar from "../../components/WebmasterSidebar";
import PatientForm from "../../components/PatientForm";
import back from "../../assets/images/icon-back.svg";

const AddPatient: React.FC = () => {
  const navigate = useNavigate();

  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <WebmasterSidebar onCollapseChange={(c) => setIsCollapsed(c)} />
      <div className="page-content">
        <h1 className="page-title">Adaugă Pacient</h1>

        <div className="table-top">
          <div className="page-return">
            <button className="button-return" onClick={() => navigate(-1)}>
              <img src={back} alt="Înapoi" className="back-icon" /> Înapoi
            </button>
          </div>
        </div>

        <div className="form-container">
          <PatientForm
            onCancel={() => navigate(-1)}
            onSuccess={() => {
              setTimeout(() => navigate("/webmaster/patients"), 1500);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddPatient;